import type { DownloadsPageLoader } from '@modules/professional/page/loaders/downloads-page-loader.server';
import { ProfessionalDownloadsSection } from './sections/ProfessionalDownloadsSection';
import { ProfessionalContactSection } from './sections/ProfessionalContactSection';

/**
 * Revamped professional Downloads tab (/downloads).
 *
 * The professional's whole download library: the files on their profile page plus
 * everything hanging off their products, projects and articles, searchable and
 * filterable, grouped by the item that owns each file.
 *
 * Laid out like the other filtered tabs: straight from the tab strip into the
 * results, with the section carrying its own heading and rule. The ground comes
 * from the profile shell, which the route handle gives this tab's deeper grey.
 */
export const ProfessionalDownloadsPageRevamp = (props: DownloadsPageLoader) => {
    return (
        <main
            id="main-content"
            data-testid="professional-downloads-page-revamp"
            className="bg-ground max-md:pb-16 md:pb-[6.25rem]"
        >
            <ProfessionalDownloadsSection {...props} />
            <ProfessionalContactSection />
        </main>
    );
};
